import { properties } from '../properties.js';
import React, { Component } from 'react';
import QRCode from "react-qr-code";
import standard_abiA from '../../abis/Standard16A-abi.json';
import standard_abiB from '../../abis/Standard16B-abi.json'
import Swal from 'sweetalert2';
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { PacmanLoader } from 'react-spinners'
import { withTranslation } from 'react-i18next';
import i18n from '../I18N/I18n.js'; 
import Cookies from 'js-cookie';
import NavBar from '../navbar.js';
import Footer from '../footer.js';
import TemplateDisplay from '../TemplateDisplay.js';
import { imprimirQR, logout, apiSecuredRequest, setBearer, isUserOrWallet, _sendMultipleFilesToIPFS, cargarIdiomaPreferido, apiSecuredRequestNoContentType} from '../functions.js';
import '../css/nftGenerator16.css';


class CertificateGenerator extends Component {

    async componentDidMount() {
      await cargarIdiomaPreferido(this.cambiarIdioma);
        // 1. Carga de Web3
        const bearer = await this.checkIfWeb3UserOrLoginUser();
        await this.cargarCamposMarca(bearer);
       
        // 2. Carga de datos de la Blockchain

      //  await this.cargarCamposMarca()
    }

    cambiarIdioma = (idioma) => {
      const { i18n } = this.props;
      i18n.changeLanguage(idioma); 
      this.forceUpdate(); 
      Cookies.set('idiomaPreferido', idioma, { expires: 365 });// Cambia el idioma usando i18n
    };

      

    logout = async () => {
        this.setState({bearer: null});
        this.setState({email: null});
        logout();
    }


    async checkIfWeb3UserOrLoginUser() { 
        let params = (new URL(document.location)).searchParams;
        this.setState({manufacturingDate: new Date()});
        this.setState({saleDate: new Date()});
        this.setState({warranty: new Date()});
        const certificadoId = params.get("certificadoId");
        this.setState({ certificadoId })
        const certificadoName = params.get("certificadoName");
        this.setState({certificadoName})
        this.setState({ isChecked: params.get("isChecked") })
        this.setState({ idProducto: params.get("idProducto") })
        this.setState({ userId: params.get("userId") })
        this.setState({ ownerAddress: params.get("ownerAddress") })
        
        const userInfo = params.get("userInfo");
        this.setState({userInfo});
        const email = Cookies.get("email");
        this.setState({ email: email });
        const userEmail = params.get("userEmail");
        this.setState({ userEmail: userEmail });
        const direccion = Cookies.get("direccion");
        this.setState({direccion: direccion})
        const bearer = Cookies.get("id");
        this.setState({ bearer: bearer });
        const userRol = Cookies.get("rol");
        this.setState({ userRol: userRol });
        let bearerVar;
        const urlInfo = window.location.pathname.split("/")
       
        this.setState({ empresaMapping: urlInfo[1] })
        
        bearerVar = Cookies.get("id");
        let account = await isUserOrWallet(email, bearerVar);
        const bearerToken = await setBearer(email, bearerVar, account);

        this.setState({account})
        
        this.setState({bearer: bearerToken})
        return bearerToken;
    }

    async cargarCamposMarca(bearer) {
        const campos = JSON.parse(localStorage.getItem('campos')); 
        this.setState({ campos })        
    }

    _cargarTemplate =  async (item) => {

      if (item.campo1A) {
        const date = new Date(item.campo1A);
    
        if (isNaN(date.getTime())) {
          console.error("Fecha inválida en campo1A:", item.campo1A);
        } else {
          item.campo1A = date;
        }
      }


      if (item.campo0) {
        const date = new Date(item.campo0);
    
        if (isNaN(date.getTime())) {
          console.error("Fecha inválida en campo1A:", item.campo0);
        } else {
          item.campo0 = date;
        }
      }

      this.setState({template: item});
      this.setState({templates: null});
      this.setState({showModal: false});
    }

     _editarTemplate =  async (item) => {
          this.setState({insertTemplate: true});
          
          const autoComplete = JSON.stringify({
            "templateName": `${item.nombre}`,
            "certificadoId": `${this.state.certificadoId}`
          });
    
          const templates = await apiSecuredRequest('post', `${properties.apiUrl}/certificat/api/S16ModelTemplate/autocomplete`, autoComplete, this.state.bearer);
          this.setState({templateToEdit: templates.data[0]});
        }



    _loadCertificateTemplates =  async (item) => {

      const autoComplete = JSON.stringify({
        "templateName": `${item}`,
        "certificadoId": `${this.state.certificadoId}`
      });

      const templates = await apiSecuredRequest('post', `${properties.apiUrl}/certificat/api/S16ModelTemplate/autocomplete`, autoComplete, this.state.bearer);
      this.setState({templates: templates.data});
    }
    

    _insertNewTemplate = async (
      templateName,
      campo1A,
      modelo,
      campo0,
      campo1,
      campo2,
      campo3,
      campo4,
      campo5,
      campo6,
      campo7,
      campo8,
      campo9,
      campo10,
      campo11,
      campo12,
      campo13,
      campo14,
      campo15,
      descripcion
    )  => {
      let templateData;
      if(this.state.templateToEdit == null) {
         templateData = JSON.stringify({
          "nombre": templateName,
          "certificado": {
            "id": this.state.certificadoId
          }, // Asumiendo que `enterpriseId` representa el ID de la empresa relacionada
          "campo1A": campo1A,
          "modelo": modelo,
          "descripcion": descripcion,
          "campoFecha": this.state.saleDateTemplate,
          "campo6": campo6, // Agrega el valor correspondiente si lo tienes
          "campo0": campo0,
          "campo1": campo1,
          "campo2": campo2,
          "campo3": campo3,
          "campo4": campo4,
          "campo5": campo5,
          "campo7": campo7,
          "campo8": campo8,
          "campo9": campo9,
          "campo10": campo10,
          "campo11": campo11,
          "campo12": campo12,
          "campo13": campo13,
          "campo14": campo14,
          "campo15": campo15
        });
      }else{
        templateData = JSON.stringify({
          "id": `${this.state.templateToEdit.id}`,
          "nombre": templateName,
          "certificado": {
            "id": this.state.certificadoId
          }, // Asumiendo que `enterpriseId` representa el ID de la empresa relacionada
          "campo1A": campo1A,
          "modelo": modelo,
          "descripcion": descripcion,
          "campoFecha": this.state.saleDateTemplate,
          "campo6": campo6, // Agrega el valor correspondiente si lo tienes
          "campo0": campo0,
          "campo1": campo1,
          "campo2": campo2,
          "campo3": campo3,
          "campo4": campo4,
          "campo5": campo5,
          "campo7": campo7,
          "campo8": campo8,
          "campo9": campo9,
          "campo10": campo10,
          "campo11": campo11,
          "campo12": campo12,
          "campo13": campo13,
          "campo14": campo14,
          "campo15": campo15
        });
      }

     
      try{

        const response = await apiSecuredRequest('post', `${properties.apiUrl}/certificat/api/S16ModelTemplate`, templateData, this.state.bearer);
        if(response.status = 200){

          if(this.state.templateToEdit == null) {
            Swal.fire({
              title: `${i18n.t('templateAdded')}`,
              confirmButtonText: `${i18n.t('continue')}`,
              confirmButtonColor: '#E94981',
              icon: 'info',
              iconColor: '#66C08B',
              width: '560px',
          })
         }else{
          Swal.fire({
            title: `${i18n.t('templateModified')}`,
            confirmButtonText: `${i18n.t('continue')}`,
            confirmButtonColor: '#E94981',
            icon: 'info',
            iconColor: '#66C08B',
            width: '560px',
        })
         }







          this.setState({showModal: true});
          this.setState({insertTemplate: false});
         
        }

      }catch (err) {
        this.setState({ errorMessage: err })
    } 
    }

    isCampoValido = (orden, valor) => {
      const campo = this.state.campos.find(campo => campo.orden === orden);
      return valor !== "" || (campo ? campo.mostrar === "false" : true);
    };
    

    _checkIfInfoCorrect = async (userInfo, campo1A, campo6, descripcion, modelo, idProducto, ownerAddress, campoFecha, 
      campo0, campo1, campo2, campo3, campo4, campo5, campo7, 
      campo8, campo9, campo10, campo11, campo12, campo13, campo14, campo15)  => {
        if (
          userInfo !== "" &&
          campo1A !== "" &&
          descripcion !== "" &&
          modelo !== "" &&
          idProducto !== "" &&
          ownerAddress !== "" &&
          campoFecha !== "" &&
          campo0 !== "" &&
          this.isCampoValido("CAMPO6", campo6) &&
          this.isCampoValido("CAMPO1", campo1) &&
          this.isCampoValido("CAMPO2", campo2) &&
          this.isCampoValido("CAMPO3", campo3) &&
          this.isCampoValido("CAMPO4", campo4) &&
          this.isCampoValido("CAMPO5", campo5) &&
          this.isCampoValido("CAMPO7", campo7) &&
          this.isCampoValido("CAMPO8", campo8) &&
          this.isCampoValido("CAMPO9", campo9) &&
          this.isCampoValido("CAMPO10", campo10) &&
          this.isCampoValido("CAMPO11", campo11) &&
          this.isCampoValido("CAMPO12", campo12) &&
          this.isCampoValido("CAMPO13", campo13) &&
          this.isCampoValido("CAMPO14", campo14) &&
          this.isCampoValido("CAMPO15", campo15)
        ) {
              let tableRows = '';
              ["CAMPO0", "CAMPO1", "CAMPO2", "CAMPO3", "CAMPO4", "CAMPO5", "CAMPO6", "CAMPO7", 
                "CAMPO8", "CAMPO9", "CAMPO10", "CAMPO11", "CAMPO12", "CAMPO13", "CAMPO14", "CAMPO15"]
               .forEach(campoKey => {
                   const campo = this.state.campos.find(campo => campo.orden === campoKey);
                   if (campo && campo.mostrar === "true") {
                       let valorCampo = eval(campoKey.toLowerCase()); // Asegúrate de que las variables están definidas (ej: campo0, campo1, etc.)
               
                       // Verificar si el campo es "CAMPO0" y si es un valor de fecha válido
                       if (campoKey === "CAMPO0" && !isNaN(new Date(valorCampo))) {
                           valorCampo = new Date(valorCampo).toLocaleString();
                       }
               
                       tableRows += `
                           <tr>
                               <td>${campo.nombreCampo}</td>
                               <td>${valorCampo}</td>
                           </tr>
                       `;
                   }
               });
               
              this.setState({ tableRows });
              Swal.fire({
                icon: 'question',
                title: `${i18n.t('iscorrect')}`,
                showDenyButton: true,
                html:
                    `
                  <style>
                    table {
                        width: 100%; /* Ensures the table uses the full width of the alert */
                        border-collapse: collapse; /* Neatly joins the borders */
                        background: #f8f8f8; /* Gives a subtle background color */
                        border-radius: 8px; /* Rounded corners for the table */
                        overflow: hidden; /* Ensures the border-radius clips the content */
                        box-shadow: 0 2px 4px rgba(0,0,0,0.1); /* Soft shadow around the table */
                    }
                    th, td {
                        padding: 12px 15px; /* Ample padding for table cells */
                        border-bottom: 1px solid #ddd; /* Light line below each row */
                    }
                    th {
                        background-color: #e94981; /* Vibrant pinkish-magenta background for the header */
                        color: white; /* White text for better readability */
                        font-size: 16px; /* Slightly larger text for headings */
                    }
                    td {
                        color: #333; /* Darker text color for better readability */
                        font-size: 14px; /* Standard text size */
                    }
                    tr:last-child td {
                        border-bottom: none; /* Removes border from the last row */
                    }
                    td:first-child {
                        text-align: right; /* Aligns the labels to the right */
                        font-weight: bold; /* Makes the labels bold */
                        background-color: #f0f0f0; /* Light grey background for labels */
                    }
                    td:last-child {
                        text-align: left; /* Ensures values are aligned to the left */
                        background-color: #f7f7f7; /* Lighter grey background for values, enhancing contrast */
                    }
                </style>
    <table>
        <thead>
            <tr>
                <th colspan="2">${i18n.t('userInfo')}</th>
            </tr>
        </thead>
        <tbody>
            <tr><td>${i18n.t('userInfo')}:</td><td>${userInfo}</td></tr>
            <tr><td>${this.state.campos.filter(campo => campo.orden == "IDPRODUCTO")[0].nombreCampo}</td><td>${idProducto}</td></tr>
            <tr><td>${i18n.t('model')}:</td><td>${modelo}</td></tr>
            <tr><td>${i18n.t('description')}:</td><td>${descripcion}</td></tr>
            <tr><td>${i18n.t('propietarioCarpeta')}:</td><td>${ownerAddress}</td></tr>
            <tr><td>${this.state.campos.filter(campo => campo.orden == "FECHA")[0].nombreCampo}</td><td>${new Date(campoFecha).toLocaleString()}</td></tr>
            <tr><td>${this.state.campos.filter(campo => campo.orden == "CAMPO1A")[0].nombreCampo}</td><td>${new Date(campo1A).toLocaleString()}</td></tr>
            ${tableRows}

        </tbody>
    </table>`

                ,
                confirmButtonText:  `${i18n.t('generateCertificate')}`,
                denyButtonText: `${i18n.t('makeChanges')}`,
                confirmButtonColor: "#E94981",
                // denyButtonColor: "#F07577",
                width: '1000px',
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    this.setState({ loading: true })
                   
                        // Después de que primeraFuncion termine, llamar a segundaFuncion
                        this._createCertificate(
                          userInfo,
                          campo1A,
                          campo6,
                          descripcion,
                          modelo,
                          idProducto,
                          ownerAddress,
                          campoFecha,
                          campo0,
                          campo1,
                          campo2,
                          campo3,
                          campo4,
                          campo5,
                          campo7,
                          campo8,
                          campo9,
                          campo10,
                          campo11,
                          campo12,
                          campo13,
                          campo14,
                          campo15
                        );
                        
                    

                } else if (result.isDenied) {
                    Swal.fire({
                        title: `${i18n.t('changesNotSaved')}`,
                        confirmButtonText: `${i18n.t('continue')}`,
                        confirmButtonColor: '#E94981',
                        icon: 'info',
                        iconColor: '#66C08B',
                        width: '560px',
                    })
                }
            })
        } else {
            Swal.fire({
                title: `${i18n.t('missingFields')}`,
                text: '',
                icon: 'error',
                confirmButton: 'Back',
                confirmButtonColor: "#E94981",
            })
        }
    }

   

    _createCertificate = async (
      userInfo,
      campo1A,
      campo6,
      descripcion,
      modelo,
      idProducto,
      ownerAddress,
      campoFecha,
      campo0,
      campo1,
      campo2,
      campo3,
      campo4,
      campo5,
      campo7,
      campo8,
      campo9,
      campo10,
      campo11,
      campo12,
      campo13,
      campo14,
      campo15
    )  => {
        let ercIdA;
        let ercIdB;
        let idProductoAVar;
        let idProductoBVar;
        let modeloVar;
        try {
          // const hash = await _sendMultipleFilesToIPFS(this.state.fileInput, this.state.fileInputB, this.state.fileInputC);
          //  const imageURI = `${properties.pinataServer}${hash.IpfsHash}/${this.state.fileInput.name}`;

          //   this.setState({imageURI})
          //     const imageURIB = this.state.fileInputB ? `${properties.pinataServer}${hash.IpfsHash}/${this.state.fileInputB.name}` : "";
          //     const imageURIC = this.state.fileInputC ? `${properties.pinataServer}${hash.IpfsHash}/${this.state.fileInputC.name}` : "";
                       
          //     this.setState({ imageURIB, imageURIC });
            if(this.state.account != 0) {
                let gasPriceVar = await web3.eth.getGasPrice();
    
                // Aumentar el gasPrice dinámicamente (por ejemplo, multiplicar por 1.5 para tener mayor prioridad)
                let gasPriceBigInt = BigInt(gasPriceVar); // Asegúrate de que sea BigInt

                // Aumentar el gasPrice multiplicando por 1.5 (multiplicar por 3 y dividir por 2)
                let gasPriceIncreased = (gasPriceBigInt * BigInt(3)) / BigInt(2);
                const abiA = standard_abiA;

                const abi = standard_abiA
                const abiB = standard_abiB
                console.log('abi', abi)
                const certificado = JSON.parse(localStorage.getItem('certificado'));
                const address = certificado.direccion;
                const addressB = certificado.direccion2;

                if(abi && address && abiB && addressB) {
             
                    const contractA = new web3.eth.Contract(abi, address)
                    const contractB = new web3.eth.Contract(abiB, addressB)

                    try{
                            const productDataCreation = await contractA.methods.createStandardDataA(userInfo, campo1A, modelo, descripcion, idProducto, ownerAddress, imageURI, campoFecha).send({
                                from: this.state.account, gasPrice: gasPriceIncreased
                            });

                            const productDataCreationB = await contractB.methods.createStandardDataB(idProducto, imageURIB, imageURIC, campo0, campo1, campo2, campo3, campo4, campo5, campo6, ownerAddress).send({
                                from: this.state.account, gasPrice: gasPriceIncreased
                            });
                            ercIdA = productDataCreation?.events?.NewStandardDataA?.returnValues?._id !== undefined 
                            ? productDataCreation.events.NewStandardDataA.returnValues._id 
                            : 'Valor predeterminado';
                            ercIdB = productDataCreationB?.events?.NewStandardDataB?.returnValues?._id !== undefined 
                            ? productDataCreationB.events.NewStandardDataB.returnValues._id 
                            : 'Valor predeterminado';
                            modeloVar =  productDataCreation.events.NewStandardDataA.returnValues._modelo;
                            idProductoAVar = productDataCreation.events.NewStandardDataA.returnValues._idProducto;
                            idProductoBVar = productDataCreationB.events.NewStandardDataB.returnValues._idProducto;

                            const qrRequestData = JSON.stringify({
                                "certificadoId": `${this.state.certificadoId}`,
                                 
                                "usuarioId": `${this.state.userId}`,
                                "standardType": "16",
                                "standard8A": {
                                  "idProducto": `${idProducto}`,
                                  "modelo": `${modelo}`
                                }
                              });


                            const response = apiSecuredRequest("post", `${properties.apiUrl}/certificat/api/web3jService/generateQR-and-send`, qrRequestData, this.state.bearer);
                            const certificateDataResult = this._createCertificateDataforCusomedUser(idProductoAVar, idProductoBVar, ercIdA, ercIdB);

                        }catch (err) {
                            this.setState({ errorMessage: err })
                            Swal.fire({
                              title: `${i18n.t('errorOccurred')}`,
                              confirmButtonText: `${i18n.t('continue')}`,
                              confirmButtonColor: '#E94981',
                              icon: 'error',
                              iconColor: '#66C08B',
                              width: '560px',
                          });
                        }
                            
                }else{
                    Swal.fire({
                        title: 'ERROR',
                        text: `${i18n.t('somethingWentWrong')}`,
                        imageUrl: `${this.state.imageUrl}`,
                        icon: 'error',
                        showCancelButton: false,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Go to admin tool'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            window.location.href = "/"
                        }
                    })

                }
            }else{

              const emuserData = JSON.parse(localStorage.getItem('userData'));

              let data = new FormData();

              let dataJson = JSON.stringify({ 
                "nombre": `${emuserData.nombre}`,
                "apellido1": `${emuserData.apellido1}`,
                "apellido2": `${emuserData.apellido2}`,
                "email": `${emuserData.email}`,
                "documento": `${emuserData.documento}`,
                "direccionPropietario": `${emuserData.ownerAddress}`,
                "ownWallet": `${emuserData.isChecked}`,
                "campo1A": `${campo1A}`,  // uint256 valor numérico
                "modelo": `${modelo}`,  // string
                "descripcion": `${descripcion}`,  // string
                "idProducto": `${idProducto}`,  // string, identificador del producto
                "campoFecha": `${campoFecha}`,  // string, campo fecha
                "campo0": `${campo0}`,  // string para el primer campo adicional
                "campo1": `${campo1}`,  // string para el segundo campo adicional
                "campo2": `${campo2}`,  // string para el tercer campo adicional
                "campo3": `${campo3}`,  // string para el cuarto campo adicional
                "campo4": `${campo4}`,  // string para el quinto campo adicional
                "campo5": `${campo5}`, 
                "campo6": `${campo6}`,
                "campo7": `${campo7}`,  // string para el sexto campo adicional
                "campo8": `${campo8}`,  // nuevo campo añadido
                "campo9": `${campo9}`,
                "campo10": `${campo10}`,
                "campo11": `${campo11}`,
                "campo12": `${campo12}`,
                "campo13": `${campo13}`,
                "campo14": `${campo14}`,
                "campo15": `${campo15}`,  
                "certificadoId": `${this.state.certificadoId}`  // ID de la empresa para obtener datos asociados
            });
            
            data.append('userData', dataJson); 
            data.append('file1', this.state.fileInput);
            data.append('file2', this.state.fileInputB);
            data.append('file3', this.state.fileInputC);
                const response = apiSecuredRequestNoContentType("post", `${properties.apiUrl}/certificat/api/standardData/standard16/create`, data, this.state.bearer);
               
            }

            this.setState({ loading: false })

            Swal.fire({
                title: 'OK',
                text: `${i18n.t('receiveEmail')}`,
                imageUrl: `${this.state.imageURI}`,
                icon: 'success',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Go to admin tool'
            }).then((result) => {
                if (result.isConfirmed) {
                   
                }
                if(result.dismiss){
                    
                }
            })
            this._generateQRCertificate();
        } catch (err) {
            this.setState({ errorMessage: err })
            let userInfo;
            Swal.fire({
              title: `${i18n.t('errorOccurred')}`,
              confirmButtonText: `${i18n.t('continue')}`,
              confirmButtonColor: '#E94981',
              icon: 'error',
              iconColor: '#66C08B',
              width: '560px',
          }); // En caso de error

        } finally {
            this.setState({ loading: false })
        }
    }

    

    _generateQRCertificate = async()  => {
      const usuario = JSON.parse(localStorage.getItem('usuarioCertificado'));
      
      // QR for quick validation generation
      const QRValidationUrl = `${properties.clientApp}/${this.state.empresaMapping}/standard16/QRValidation?nombre=${usuario.nombre}` +
        `&apellido1=${usuario.apellido1}&apellido2=${usuario.apellido2}&email=${usuario.email}` +
        `&idProducto=${this.state.idProducto}&account=${usuario.walletDir}` +
        `&documento=${usuario.documento}&certificadoId=${this.state.certificadoId}`;
      this.setState({ QRCode: QRValidationUrl });
      this.setState({ showQRcode: true })
    }

    _createCertificateDataforCusomedUser = async (idProductoA, idProductoB, erc721A, erc721B) => {
        if (idProductoA == idProductoB && this.state.account != 0) {

            const apiUserNfts = await apiSecuredRequest(
                "get", 
                `${properties.apiUrl}/certificat/api/standardData/standardInfo/getByUseridAndEnterpriseId/${this.state.userId}/${this.state.certificadoId}/16/${idProductoA}`, 
                "", 
                this.state.bearer
            );
            if (apiUserNfts.data.length == 0) {

                let certificateData = JSON.stringify({
                    "idProducto": `${idProductoA}`,
                    "erc721IdA": `${erc721A}`,
                    "erc721IdB": `${erc721B}`,
                    "erc721IdC": null,
                    "userId": `${this.state.userId}`,
                    "certificadoId": `${this.state.certificadoId}`,
                    "validated": false,
                    "standardType": "16"
                });
                const config = await apiSecuredRequest(
                    "post", 
                    `${properties.apiUrl}/certificat/api/standardData/request`, 
                    certificateData, 
                    this.state.bearer
                );
    
                console.log(config);
                return config.data;

            } 

        }

    }

    constructor(props) {
        super(props)
        this.state = {
            account: "0x0",
            userInfo: null,
            contractA: null,
            contractB: null,
            fileInput: null,
            fileInputB: null,
            fileInputC: null,
            imageURI: null,
            imageURIB: null,
            imageURIC: null,
            isRootDir: null,
            saleDate: null,
            manufacturingDate: null,
            warranty: null,
            idProducto: null,
            ownerAddress: null,
            userId: null,
            email: null,
            userEmail: null,
            isChecked: null,
            empresaMapping: null,
            certificadoId: null,
            certificadoName: null,
            loading: false,
            campos: null,
            showModal: false,
            insertTemplate: null,
            templates: null,
            template: null,
            templateToEdit: null,
            QRcode: null,
            showQRcode: false,
            tableRows: null
        }
    }

    render() {

        if (this.state.loading == true) {
            return (

                <>
                 <NavBar mail={this.state.email} bearer={this.state.bearer} logout={this.logout} cambiarIdioma={this.cambiarIdioma} />
                   <div>
                    <h1>Certificate Generator</h1>
                   
                </div>

                <div>
                    <PacmanLoader color="#E94981" cssOverride={{}} />
                </div>
                <Footer />
                </>
            );
        } else if (this.state.campos != null) {
          const campo0 = this.state.campos.find((campo) => campo.orden === "CAMPO0");
          const campo1 = this.state.campos.find((campo) => campo.orden === "CAMPO1");
          const campo2 = this.state.campos.find((campo) => campo.orden === "CAMPO2");
          const campo3 = this.state.campos.find((campo) => campo.orden === "CAMPO3");
          const campo4 = this.state.campos.find((campo) => campo.orden === "CAMPO4");
          const campo5 = this.state.campos.find((campo) => campo.orden === "CAMPO5");
          const campo6 = this.state.campos.find((campo) => campo.orden === "CAMPO6");
          const campo7 = this.state.campos.find((campo) => campo.orden === "CAMPO7");
          const campo8 = this.state.campos.find((campo) => campo.orden === "CAMPO8");
          const campo9 = this.state.campos.find((campo) => campo.orden === "CAMPO9");
          const campo10 = this.state.campos.find((campo) => campo.orden === "CAMPO10");
          const campo11 = this.state.campos.find((campo) => campo.orden === "CAMPO11");
          const campo12 = this.state.campos.find((campo) => campo.orden === "CAMPO12");
          const campo13 = this.state.campos.find((campo) => campo.orden === "CAMPO13");
          const campo14 = this.state.campos.find((campo) => campo.orden === "CAMPO14");
          const campo15 = this.state.campos.find((campo) => campo.orden === "CAMPO15");

            return (
                <>
                       
                       <NavBar mail={this.state.email} bearer={this.state.bearer} logout={this.logout} cambiarIdioma={this.cambiarIdioma} />

<div className="cewy-main-content16">
  <h1 className="cewy-content-title">{i18n.t('certificateGenerator')}</h1>
  {this.state.showQRcode != false && (
                         <div className="modal-overlay">
                  <div className="modal-content form">
                      <button className="modal-close" onClick={() => this.setState({ showQRcode: false })}>
                          {i18n.t('close')}
                      </button>

                      <div className="cewy-qrcode-container">
                          <QRCode value={this.state.QRCode} />

                          <button className="cewy-qrcode-button" onClick={() => imprimirQR(this.state.QRCode)}>
                              {i18n.t('imprimirQR')}
                          </button>
                      </div>
                  </div>
                        
                        </div>
                      
                        
                      )}
  <button text="Back" className="cewy-button-link" onClick={(event) => {
                        const url = `/${this.state.empresaMapping}/standard16/privateKeyGenerator?certificadoId=${this.state.certificadoId}&standardType=16`
                        localStorage.removeItem('usuarioCertificado')
                        window.location.href = url
                    }} >{i18n.t('backToUserInfo')} </button>

    <button className="cewy-button-link cewy-button-right" onClick={() => this.setState({showModal: true})}>
        {i18n.t('loadTemplate')}
    </button>
  <div className="cewy-centered-container">
  
  <form
  onSubmit={(event) => {
    event.preventDefault();
    const userInfo = this.userInfo?.value || "";
    const descripcion = this.descripcion?.value || "";
    const modelo = this.modelo?.value || "";
    const idProducto = this.idProducto?.value || "";
    const ownerAddress = this.ownerAddress?.value || "";

    const getCampoValue = (orden, ref) => {
      const campo = this.state.campos.find((campo) => campo.orden === orden);
      return campo && campo.mostrar === "true" ? ref?.value || "" : "";
    };

   
    const campo1 = getCampoValue("CAMPO1", this.campo1);
    const campo2 = getCampoValue("CAMPO2", this.campo2);
    const campo3 = getCampoValue("CAMPO3", this.campo3);
    const campo4 = getCampoValue("CAMPO4", this.campo4);
    const campo5 = getCampoValue("CAMPO5", this.campo5);
    const campo6 = getCampoValue("CAMPO6", this.campo6);
    const campo7 = getCampoValue("CAMPO7", this.campo7);
    const campo8 = getCampoValue("CAMPO8", this.campo8);
    const campo9 = getCampoValue("CAMPO9", this.campo9);
    const campo10 = getCampoValue("CAMPO10", this.campo10);
    const campo11 = getCampoValue("CAMPO11", this.campo11);
    const campo12 = getCampoValue("CAMPO12", this.campo12);
    const campo13 = getCampoValue("CAMPO13", this.campo13);
    const campo14 = getCampoValue("CAMPO14", this.campo14);
    const campo15 = getCampoValue("CAMPO15", this.campo15);

    const campoFecha = this.state.saleDate.toISOString();

    let manufacturingDate;
    if(this.state.campos.filter((campo) => campo.orden == "CAMPO1A")[0].tipoCampo !== "Date" ){
      manufacturingDate = getCampoValue("CAMPO1A", this.campo1A);
    }else{
      manufacturingDate = this.state.manufacturingDate.toISOString();
    }

    let saleDate;
    if(this.state.campos.filter((campo) => campo.orden == "CAMPO0")[0].tipoCampo !== "Date" ){
      saleDate = getCampoValue("CAMPO0", this.campo0);
    }else{
      saleDate = this.state.manufacturingDate.toISOString();
    }
    

    this._checkIfInfoCorrect(
      userInfo,
      manufacturingDate,
      campo6,
      descripcion,
      modelo,
      idProducto,
      ownerAddress,
      campoFecha,
      saleDate,
      campo1,
      campo2,
      campo3,
      campo4,
      campo5,
      campo7,
      campo8,
      campo9,
      campo10,
      campo11,
      campo12,
      campo13,
      campo14,
      campo15
    );
  }}
  className="cewy-form"
>
      {/* User Info centered at the top */}
      <div className="cewy-userinfo-container">
        <label className="cewy-label">{i18n.t("userInfo")}</label>
        <input
          type="text"
          defaultValue={this.state.userInfo}
          ref={(userInfo) => (this.userInfo = userInfo)}
          disabled
          className="cewy-input"
        />

        <label className="cewy-label">{i18n.t("model")}</label>
          {this.state.template == null ?     <input
            type="text"
            ref={(modelo) => (this.modelo = modelo)}
            className="cewy-input"
          />: 
          <input
          type="text" defaultValue = {this.state.template.modelo}
          ref={(modelo) => (this.modelo = modelo)}
          className="cewy-input"
        />}
        <label className="cewy-label">
            {i18n.t(this.state.campos.filter((campo) => campo.orden == "IDPRODUCTO")[0].nombreCampo)}
          </label>
          <input
            type="text"
            defaultValue={this.state.idProducto}
            ref={(idProducto) => (this.idProducto = idProducto)}
            disabled
            className="cewy-input"
          />
      </div>

      {/* Two-column layout for inputs */}
      <div className="cewy-input-columns">

        <div className="cewy-column left">
        <label className="cewy-label">
          {i18n.t(this.state.campos.filter((campo) => campo.orden == "CAMPO1A")[0].nombreCampo)}
           
          </label>
          {this.state.campos.filter((campo) => campo.orden == "CAMPO1A")[0].tipoCampo !== "Date" ? (
  <>

    {this.state.template == null ? (
      <input
        type="text"
        ref={(campo1A) => (this.campo1A = campo1A)}
        className="cewy-input"
      />
    ) : (
      <input
        type="text"
        defaultValue={this.state.template.campo1A}
        ref={(campo1A) => (this.campo1A = campo1A)}
        className="cewy-input"
      />
    )}
  </>
) : (
  <>

    {this.state.template == null ? (
      <DatePicker
        dateFormat="dd/MM/yyyy, HH:mm"
        showTimeSelect
        timeFormat="HH:mm"
        selected={this.state.manufacturingDate}
        onChange={(manufacturingDate) => this.setState({ manufacturingDate })}
        className="cewy-datepicker"
      />
    ) : (
      <DatePicker
        dateFormat="dd/MM/yyyy, HH:mm"
        showTimeSelect
        timeFormat="HH:mm"
        selected={this.state.template.campo1A}
        onChange={(campo1A) =>
          this.setState({
            template: {
              ...this.state.template,
              campo1A,
            },
          })
        }
        className="cewy-datepicker"
      />
    )}
  </>
)}
           {campo1 && campo1.mostrar === "true" && (
            <>
              <label className="cewy-label">
                {i18n.t(campo1.nombreCampo)}
              </label>
              {this.state.template == null ? (
                <input type="text" ref={(campo1) => (this.campo1 = campo1)} className="cewy-input" />
              ) : (
                <input type="text" defaultValue={this.state.template.campo1} ref={(campo1) => (this.campo1 = campo1)} className="cewy-input" />
              )}
            </>
          )}


          {campo3 && campo3.mostrar === "true" && (
            <>
              <label className="cewy-label">
                {i18n.t(campo3.nombreCampo)}
              </label>
              {this.state.template == null ? (
                <input type="text" ref={(campo3) => (this.campo3 = campo3)} className="cewy-input" />
              ) : (
                <input type="text" defaultValue={this.state.template.campo3} ref={(campo3) => (this.campo3 = campo3)} className="cewy-input" />
              )}
            </>
          )}

          {campo5 && campo5.mostrar === "true" && (
            <>
              <label className="cewy-label">
                {i18n.t(campo5.nombreCampo)}
              </label>
              {this.state.template == null ? (
                <input type="text" ref={(campo5) => (this.campo5 = campo5)} className="cewy-input" />
              ) : (
                <input type="text" value={this.state.template.campo5} ref={(campo5) => (this.campo5 = campo5)} className="cewy-input" />
              )}
            </>
          )}
            {campo7 && campo7.mostrar === "true" && (
  <>
              <label className="cewy-label">
                {i18n.t(campo7.nombreCampo)}
              </label>
              {this.state.template == null ? (
                <input type="text" ref={(campo7) => (this.campo7 = campo7)} className="cewy-input" />
              ) : (
                <input type="text" defaultValue={this.state.template.campo7} ref={(campo7) => (this.campo7 = campo7)} className="cewy-input" />
              )}
            </>
          )}
            {campo9 && campo9.mostrar === "true" && (
              <>
                <label className="cewy-label">
                  {i18n.t(campo9.nombreCampo)}
                </label>
                {this.state.template == null ? (
                  <input type="text" ref={(campo9) => (this.campo9 = campo9)} className="cewy-input" />
                ) : (
                  <input type="text" value={this.state.template.campo9} ref={(campo9) => (this.campo9 = campo9)} className="cewy-input" />
                )}
              </>
            )}
            {campo11 && campo11.mostrar === "true" && (
              <>
                <label className="cewy-label">
                  {i18n.t(campo11.nombreCampo)}
                </label>
                {this.state.template == null ? (
                  <input type="text" ref={(campo11) => (this.campo11 = campo11)} className="cewy-input" />
                ) : (
                  <input type="text" defaultValue={this.state.template.campo11} ref={(campo11) => (this.campo11 = campo11)} className="cewy-input" />
                )}
              </>
            )}

            {campo13 && campo13.mostrar === "true" && (
              <>
                <label className="cewy-label">
                  {i18n.t(campo13.nombreCampo)}
                </label>
                {this.state.template == null ? (
                  <input type="text" ref={(campo13) => (this.campo13 = campo13)} className="cewy-input" />
                ) : (
                  <input type="text" value={this.state.template.campo13} ref={(campo13) => (this.campo13 = campo13)} className="cewy-input" />
                )}
              </>
            )}  

            {campo15 && campo15.mostrar === "true" && (
              <>
                <label className="cewy-label">
                  {i18n.t(campo15.nombreCampo)}
                </label>
                {this.state.template == null ? (
                  <input type="text" ref={(campo15) => (this.campo15 = campo15)} className="cewy-input" />
                ) : (
                  <input type="text" defaultValue={this.state.template.campo15} ref={(campo15) => (this.campo15 = campo15)} className="cewy-input" />
                )}
              </>
            )}

    

        </div>

        <div className="cewy-column right">

        <label className="cewy-label">
          {i18n.t(this.state.campos.filter((campo) => campo.orden == "CAMPO0")[0].nombreCampo)}
           
          </label>
          {this.state.campos.filter((campo) => campo.orden == "CAMPO0")[0].tipoCampo !== "Date" ? (
  <>

    {this.state.template == null ? (
      <input
        type="text"
        ref={(campo0) => (this.campo0 = campo0)}
        className="cewy-input"
      />
    ) : (
      <input
        type="text"
        defaultValue={this.state.template.campo0}
        ref={(campo0) => (this.campo0 = campo0)}
        className="cewy-input"
      />
    )}
  </>
) : (
  <>

    {this.state.template == null ? (
      <DatePicker
        dateFormat="dd/MM/yyyy, HH:mm"
        showTimeSelect
        timeFormat="HH:mm"
        selected={this.state.saleDate}
        onChange={(saleDate) => this.setState({ saleDate })}
        className="cewy-datepicker"
      />
    ) : (
      <DatePicker
        dateFormat="dd/MM/yyyy, HH:mm"
        showTimeSelect
        timeFormat="HH:mm"
        selected={this.state.template.campo0}
        onChange={(campo0) =>
          this.setState({
            template: {
              ...this.state.template,
              campo0,
            },
          })
        }
        className="cewy-datepicker"
      />
    )}
  </>
)}


{campo2 && campo2.mostrar === "true" && (
          <>
            <label className="cewy-label">
              {i18n.t(campo2.nombreCampo)}
            </label>
            {this.state.template == null ? (
              <input type="text" ref={(campo2) => (this.campo2 = campo2)} className="cewy-input" />
            ) : (
              <input type="text" defaultValue={this.state.template.campo2} ref={(campo2) => (this.campo2 = campo2)} className="cewy-input" />
            )}
          </>
        )}

         
        {campo4 && campo4.mostrar === "true" && (
          <>
            <label className="cewy-label">
              {i18n.t(campo4.nombreCampo)}
            </label>
            {this.state.template == null ? (
              <input type="text" ref={(campo4) => (this.campo4 = campo4)} className="cewy-input" />
            ) : (
              <input type="text" defaultValue={this.state.template.campo4} ref={(campo4) => (this.campo4 = campo4)} className="cewy-input" />
            )}
          </>
        )}

{campo6 && campo6.mostrar === "true" && (
  <>
    <label className="cewy-label">
      {i18n.t(campo6.nombreCampo)}
    </label>
    {this.state.template == null ? (
      <input type="text" ref={(campo6) => (this.campo6 = campo6)} className="cewy-input" />
    ) : (
      <input type="text" defaultValue={this.state.template.campo6} ref={(campo6) => (this.campo6 = campo6)} className="cewy-input" />
    )}
  </>
)}

{campo8 && campo8.mostrar === "true" && (
  <>
    <label className="cewy-label">
      {i18n.t(campo8.nombreCampo)}
    </label>
    {this.state.template == null ? (
      <input type="text" ref={(campo8) => (this.campo8 = campo8)} className="cewy-input" />
    ) : (
      <input type="text" defaultValue={this.state.template.campo8} ref={(campo8) => (this.campo8 = campo8)} className="cewy-input" />
    )}
  </>
)}

{campo10 && campo10.mostrar === "true" && (
  <>
    <label className="cewy-label">
      {i18n.t(campo10.nombreCampo)}
    </label>
    {this.state.template == null ? (
      <input type="text" ref={(campo10) => (this.campo10 = campo10)} className="cewy-input" />
    ) : (
      <input type="text" defaultValue={this.state.template.campo10} ref={(campo10) => (this.campo10 = campo10)} className="cewy-input" />
    )}
  </>
)}

        

          {campo12 && campo12.mostrar === "true" && (
            <>
              <label className="cewy-label">
                {i18n.t(campo12.nombreCampo)}
              </label>
              {this.state.template == null ? (
                <input type="text" ref={(campo12) => (this.campo12 = campo12)} className="cewy-input" />
              ) : (
                <input type="text" defaultValue={this.state.template.campo12} ref={(campo12) => (this.campo12 = campo12)} className="cewy-input" />
              )}
            </>
          )}

            {campo14 && campo14.mostrar === "true" && (
              <>
                <label className="cewy-label">
                  {i18n.t(campo14.nombreCampo)}
                </label>
                {this.state.template == null ? (
                  <input type="text" ref={(campo14) => (this.campo14 = campo14)} className="cewy-input" />
                ) : (
                  <input type="text" defaultValue={this.state.template.campo14} ref={(campo14) => (this.campo14 = campo14)} className="cewy-input" />
                )}
              </>
            )}


      

        
         
        </div>
      </div>

      {/* DatePicker and Description centered below */}
      <div className="cewy-datepicker-container">
      <label className="cewy-label">
    {i18n.t(this.state.campos.filter((campo) => campo.orden == "FECHA")[0].nombreCampo)}
  </label>
  {this.state.campos.filter((campo) => campo.orden == "FECHA")[0].tipoCampo === "Date" ? (
    this.state.template == null ? (
      <DatePicker
        dateFormat="dd/MM/yyyy, HH:mm"
        showTimeSelect
        timeFormat="HH:mm"
        selected={this.state.saleDate}
        onChange={(saleDate) => this.setState({ saleDate })}
        className="cewy-datepicker"
      />
    ) : (
      <DatePicker
        dateFormat="dd/MM/yyyy, HH:mm"
        showTimeSelect
        timeFormat="HH:mm"
        selected={this.state.saleDate}
        onChange={(campoFecha) =>
          this.setState({
            template: {
              ...this.state.template,
              campoFecha,
            },
          })
        }
        className="cewy-datepicker"
      />
    )
  ) : (
    this.state.template == null ? (
      <input
        type="text"
        className="cewy-input"
        defaultValue={this.state.saleDate || ""}
        onChange={(e) => this.setState({ saleDate: e.target.value })}
      />
    ) : (
      <input
        type="text"
        className="cewy-input"
        defaultValue={this.state.template.campoFecha || ""}
        onChange={(e) =>
          this.setState({
            template: {
              ...this.state.template,
              campoFecha: e.target.value,
            },
          })
        }
      />
    )
  )}
  
                                    <div className="margin">
                                    <label className="cewy-label">{i18n.t('productImage')} 1</label>
                                    <input type="file" className="cewy-input cevy-file-upload"
                                          onChange={(e) => this.setState({ fileInput: e.target.files[0] })} required />
                                    </div>
                                    <div className="margin">
                                        <label className="cewy-label">{i18n.t('productImage')} 2</label>
                                        <input type="file" className="cewy-input cevy-file-upload"
                                            onChange={(i) => this.setState({ fileInputB: i.target.files[0] })} />
                                    </div>
                                    <div className="margin">
                                        <label className="cewy-label">{i18n.t('productImage')} 3 ({i18n.t('videoSupported')})</label>
                                        <input type="file" className="cewy-input cevy-file-upload"
                                            onChange={(j) => this.setState({ fileInputC: j.target.files[0] })} />                                                                
                                      
      </div>
         <div className="cewy-lower-margin">
                 <label className="cewy-label">{i18n.t('propietarioCarpeta')}</label>
                 <input type="text" className="cewy-input" placeholder={i18n.t('propietarioCarpeta')} defaultValue={this.state.ownerAddress} ref={(ownerAddress) => this.ownerAddress = ownerAddress} disabled />
         </div>
      </div>

      <div className="cewy-form-group">
        <label className="cewy-label">{i18n.t("description")}</label>
        {this.state.template == null ?      <textarea id="resizable-textarea" className="cewy-textarea-adjustable" ref={(descripcion) => this.descripcion = descripcion}></textarea>: 
         <textarea id="resizable-textarea"  defaultValue = {this.state.template.descripcion} className="cewy-textarea-adjustable" ref={(descripcion) => this.descripcion = descripcion}></textarea>} 
      </div>

      <div className="cewy-button-container">
          <button id="generate-button" className="cewy-centered-button" type="submit">{i18n.t('generateCertificate')}</button>
          <button className="cewy-centered-button" onClick={() => {
          localStorage.removeItem('usuarioCertificado')
          window.location.href = `/listaEmpresas`
       
       }}> {i18n.t('backToEnterprise')}
         </button>
         
      </div>
    </form>
  </div>
</div>

<Footer />

      {this.state.showModal && (
            <div className="modal-overlay">
                <div className="modal-content">
                    
                    <label className="cewy-input-label">{i18n.t('template')}</label>
                    <input type="email" className="modal-input" ref={(templateModal) => this.templateModal = templateModal} />
                    <button className="modal-button" onClick={() => this._loadCertificateTemplates(this.templateModal.value)}>
                        {i18n.t('loadTemplate')}
                    </button>
                    <button className="modal-close" onClick={() => this.setState({ showModal: false })}>
                        {i18n.t('close')}
                    </button>

                    <button className="modal-button" onClick={() => 
                    
                        this.setState({ showModal: false, insertTemplate: true })
                           
                      }>
                        {i18n.t('insertTemplate')}
                    </button>
                
                
                    <TemplateDisplay items = {this.state.templates} cargarTemplate={this._cargarTemplate} editarTemplate={this._editarTemplate}/>
                </div>
            </div>
        )}

{this.state.insertTemplate && (
  <div className="modal-overlay2">
    <div className="modal-content2 form-container">
      
      <div className="form-column">
        <label className="form-input-label">{i18n.t('templateName')}</label>

        {this.state.templateToEdit == null ? (
      <input
        type="text"
        ref={(templateName) => (this.templateName = templateName)}
        className="form-input"
      />
    ) : (
      <input
        type="text"
        defaultValue={this.state.templateToEdit.nombre}
        ref={(templateName) => (this.templateName = templateName)}
        className="form-input"
      />
    )}
    
        <label className="cewy-label">
          {i18n.t(this.state.campos.filter((campo) => campo.orden == "CAMPO1A")[0].nombreCampo)}
           
          </label>
          {this.state.campos.filter((campo) => campo.orden == "CAMPO1A")[0].tipoCampo !== "Date" ? (
  <>

    


    {this.state.templateToEdit == null ? (
      <input
        type="text"
        ref={(campo1A) => (this.campo1A = campo1A)}
        className="form-input"
      />
    ) : (
      <input
        type="text"
        defaultValue={this.state.templateToEdit.campo1A}
        ref={(campo1A) => (this.campo1A = campo1A)}
        className="form-input"
      />
    )}
  </>
) : (
  <>

    {this.state.templateToEdit == null ? (
      <DatePicker
        dateFormat="dd/MM/yyyy, HH:mm"
        showTimeSelect
        timeFormat="HH:mm"
        selected={this.state.manufacturingDate}
        onChange={(manufacturingDate) => this.setState({ manufacturingDate })}
        className="cewy-datepicker"
      />
    ) : (
      <DatePicker
      dateFormat="dd/MM/yyyy, HH:mm"
      showTimeSelect
      timeFormat="HH:mm"
      selected={
        this.state.templateToEdit.campo1A
          ? new Date(this.state.templateToEdit.campo1A)
          : null
      }
      onChange={(manufacturingDate) => this.setState({ manufacturingDate })}
      className="cewy-datepicker"
    />
    )}
  </>
)}








        {campo1 && campo1.mostrar === "true" && (
          <>
            <label className="form-input-label">
              {i18n.t(campo1.nombreCampo)}
            </label>
            {this.state.templateToEdit == null ? (
      <input
        type="text"
        ref={(campo1) => (this.campo1 = campo1)}
        className="form-input"
      />
    ) : (
      <input
        type="text"
        defaultValue={this.state.templateToEdit.campo1A}
        ref={(campo1) => (this.campo1 = campo1)}
        className="form-input"
      />
    )}
          </>
        )}

        {campo3 && campo3.mostrar === "true" && (
          <>
            <label className="form-input-label">
              {i18n.t(campo3.nombreCampo)}
            </label>
            {
  this.state.templateToEdit == null ? (
    <input
      type="email"
      ref={(campo3) => (this.campo3 = campo3)}
      className="form-input"
    />
  ) : (
    <input
      type="email"
      defaultValue={this.state.templateToEdit.campo3 || ""}
      ref={(campo3) => (this.campo3 = campo3)}
      className="form-input"
    />
  )
}
          </>
        )}

        {campo5 && campo5.mostrar === "true" && (
          <>
            <label className="form-input-label">
              {i18n.t(campo5.nombreCampo)}
            </label>
            {
  this.state.templateToEdit == null ? (
    <input
      type="email"
      ref={(campo5) => (this.campo5 = campo5)}
      className="form-input"
    />
  ) : (
    <input
      type="email"
      defaultValue={this.state.templateToEdit.campo5 || ""}
      ref={(campo5) => (this.campo5 = campo5)}
      className="form-input"
    />
  )
}
          </>
        )}

        {campo7 && campo7.mostrar === "true" && (
          <>
            <label className="form-input-label">
              {i18n.t(campo7.nombreCampo)}
            </label>
            {
  this.state.templateToEdit == null ? (
    <input
      type="email"
      ref={(campo7) => (this.campo7 = campo7)}
      className="form-input"
    />
  ) : (
    <input
      type="email"
      defaultValue={this.state.templateToEdit.campo7 || ""}
      ref={(campo7) => (this.campo7 = campo7)}
      className="form-input"
    />
  )
}
          </>
        )}

        {campo9 && campo9.mostrar === "true" && (
          <>
            <label className="form-input-label">
              {i18n.t(campo9.nombreCampo)}
            </label>
            {
  this.state.templateToEdit == null ? (
    <input
      type="email"
      ref={(campo9) => (this.campo9 = campo9)}
      className="form-input"
    />
  ) : (
    <input
      type="email"
      defaultValue={this.state.templateToEdit.campo9 || ""}
      ref={(campo9) => (this.campo9 = campo9)}
      className="form-input"
    />
  )
}
          </>
        )}
        {campo11 && campo11.mostrar === "true" && (
          <>
            <label className="form-input-label">
              {i18n.t(campo11.nombreCampo)}
            </label>
            {
  this.state.templateToEdit == null ? (
    <input
      type="email"
      ref={(campo11) => (this.campo11 = campo11)}
      className="form-input"
    />
  ) : (
    <input
      type="email"
      defaultValue={this.state.templateToEdit.campo11 || ""}
      ref={(campo11) => (this.campo11 = campo11)}
      className="form-input"
    />
  )
}
          </>
        )}

        {campo13 && campo13.mostrar === "true" && (
          <>
            <label className="form-input-label">
              {i18n.t(campo13.nombreCampo)}
            </label>
            {
  this.state.templateToEdit == null ? (
    <input
      type="email"
      ref={(campo13) => (this.campo13 = campo13)}
      className="form-input"
    />
  ) : (
    <input
      type="email"
      defaultValue={this.state.templateToEdit.campo13 || ""}
      ref={(campo13) => (this.campo13 = campo13)}
      className="form-input"
    />
  )
}
          </>
        )}

        {campo15 && campo15.mostrar === "true" && (
          <>
            <label className="form-input-label">
              {i18n.t(campo15.nombreCampo)}
            </label>
            {
  this.state.templateToEdit == null ? (
    <input
      type="email"
      ref={(campo15) => (this.campo15 = campo15)}
      className="form-input"
    />
  ) : (
    <input
      type="email"
      defaultValue={this.state.templateToEdit.campo15 || ""}
      ref={(campo15) => (this.campo15 = campo15)}
      className="form-input"
    />
  )
}
          </>
        )}



        <label className="form-input-label">{i18n.t('description')}</label>
        {
  this.state.templateToEdit == null ? (
    <textarea
      id="resizable-textarea"
      className="cewy-textarea-adjustable"
      ref={(descripcion) => this.descripcion = descripcion}
    />
  ) : (
    <textarea
      id="resizable-textarea"
      className="cewy-textarea-adjustable"
      defaultValue={this.state.templateToEdit.descripcion || ""}
      ref={(descripcion) => this.descripcion = descripcion}
    />
  )
}
      </div>

      <div className="form-column">
      <label className="form-input-label">{i18n.t("model")}</label>
      {
  this.state.templateToEdit == null ? (
    <input
      type="text"
      ref={(modelo) => (this.modelo = modelo)}
      className="form-input"
    />
  ) : (
    <input
      type="text"
      defaultValue={this.state.templateToEdit.modelo || ""}
      ref={(modelo) => (this.modelo = modelo)}
      className="form-input"
    />
  )
}



<label className="cewy-label">
          {i18n.t(this.state.campos.filter((campo) => campo.orden == "CAMPO0")[0].nombreCampo)}
           
          </label>
          {this.state.campos.filter((campo) => campo.orden == "CAMPO0")[0].tipoCampo !== "Date" ? (
  <>

    


    {this.state.templateToEdit == null ? (
      <input
        type="text"
        ref={(campo0) => (this.campo0 = campo0)}
        className="form-input"
      />
    ) : (
      <input
        type="text"
        defaultValue={this.state.templateToEdit.campo0}
        ref={(campo0) => (this.campo0 = campo0)}
        className="form-input"
      />
    )}
  </>
) : (
  <>

    {this.state.templateToEdit == null ? (
      <DatePicker
        dateFormat="dd/MM/yyyy, HH:mm"
        showTimeSelect
        timeFormat="HH:mm"
        selected={this.state.saleDate}
        onChange={(saleDate) => this.setState({ saleDate })}
        className="cewy-datepicker"
      />
    ) : (
      <DatePicker
      dateFormat="dd/MM/yyyy, HH:mm"
      showTimeSelect
      timeFormat="HH:mm"
      selected={
        this.state.templateToEdit.campo0
          ? new Date(this.state.templateToEdit.campo0)
          : null
      }
      onChange={(saleDate) => this.setState({ saleDate })}
      className="cewy-datepicker"
    />
    )}
  </>
)}
      

        {campo2 && campo2.mostrar === "true" && (
          <>
            <label className="form-input-label">
            {i18n.t(campo2.nombreCampo)}
            </label>
            {
  this.state.templateToEdit == null ? (
    <input
      type="email"
      ref={(campo2) => (this.campo2 = campo2)}
      className="form-input"
    />
  ) : (
    <input
      type="email"
      defaultValue={this.state.templateToEdit.campo2 || ""}
      ref={(campo2) => (this.campo2 = campo2)}
      className="form-input"
    />
  )
}
          </>
        )}



        {campo4 && campo4.mostrar === "true" && (
          <>
            <label className="form-input-label">
              {i18n.t(campo4.nombreCampo)}
            </label>
            {
  this.state.templateToEdit == null ? (
    <input
      type="email"
      ref={(campo4) => (this.campo4 = campo4)}
      className="form-input"
    />
  ) : (
    <input
      type="email"
      defaultValue={this.state.templateToEdit.campo4 || ""}
      ref={(campo4) => (this.campo4 = campo4)}
      className="form-input"
    />
  )
}
          </>
        )}


        {campo6 && campo6.mostrar === "true" && (
          <>
            <label className="form-input-label">
              {i18n.t(campo6.nombreCampo)}
            </label>
            {
  this.state.templateToEdit == null ? (
    <input
      type="email"
      ref={(campo6) => (this.campo6 = campo6)}
      className="form-input"
    />
  ) : (
    <input
      type="email"
      defaultValue={this.state.templateToEdit.campo6 || ""}
      ref={(campo6) => (this.campo6 = campo6)}
      className="form-input"
    />
  )
}
          </>
        )}


        {campo8 && campo8.mostrar === "true" && (
          <>
            <label className="form-input-label">
              {i18n.t(campo8.nombreCampo)}
            </label>
            {
  this.state.templateToEdit == null ? (
    <input
      type="email"
      ref={(campo8) => (this.campo8 = campo8)}
      className="form-input"
    />
  ) : (
    <input
      type="email"
      defaultValue={this.state.templateToEdit.campo8 || ""}
      ref={(campo8) => (this.campo8 = campo8)}
      className="form-input"
    />
  )
}
          </>
        )}


        {campo10 && campo10.mostrar === "true" && (
          <>
            <label className="form-input-label">
              {i18n.t(campo10.nombreCampo)}
            </label>
            {
  this.state.templateToEdit == null ? (
    <input
      type="email"
      ref={(campo10) => (this.campo10 = campo10)}
      className="form-input"
    />
  ) : (
    <input
      type="email"
      defaultValue={this.state.templateToEdit.campo10 || ""}
      ref={(campo10) => (this.campo10 = campo10)}
      className="form-input"
    />
  )
}
          </>
        )}


        {campo12 && campo12.mostrar === "true" && (
          <>
            <label className="form-input-label">
              {i18n.t(campo12.nombreCampo)}
            </label>
            {
  this.state.templateToEdit == null ? (
    <input
      type="email"
      ref={(campo12) => (this.campo12 = campo12)}
      className="form-input"
    />
  ) : (
    <input
      type="email"
      defaultValue={this.state.templateToEdit.campo12 || ""}
      ref={(campo12) => (this.campo12 = campo12)}
      className="form-input"
    />
  )
}
          </>
        )}

        {campo14 && campo14.mostrar === "true" && (
          <>
            <label className="form-input-label">
              {i18n.t(campo14.nombreCampo)}
            </label>
            {
  this.state.templateToEdit == null ? (
    <input
      type="email"
      ref={(campo14) => (this.campo14 = campo14)}
      className="form-input"
    />
  ) : (
    <input
      type="email"
      defaultValue={this.state.templateToEdit.campo14 || ""}
      ref={(campo14) => (this.campo14 = campo14)}
      className="form-input"
    />
  )
}
          </>
        )}
      </div>

      <button
        className="modal-button"
        onClick={() =>{
          const getCampoValue = (orden, ref) => {
            const campo = this.state.campos.find((campo) => campo.orden === orden);
            return campo && campo.mostrar === "true" ? ref?.value || "" : "";
          };

          const campo1 = getCampoValue("CAMPO1", this.campo1);
          const campo2 = getCampoValue("CAMPO2", this.campo2);
          const campo3 = getCampoValue("CAMPO3", this.campo3);
          const campo4 = getCampoValue("CAMPO4", this.campo4);
          const campo5 = getCampoValue("CAMPO5", this.campo5);
          const campo6 = getCampoValue("CAMPO6", this.campo6);
          const campo7 = getCampoValue("CAMPO7", this.campo7);
          const campo8 = getCampoValue("CAMPO8", this.campo8);
          const campo9 = getCampoValue("CAMPO9", this.campo9);
          const campo10 = getCampoValue("CAMPO10", this.campo10);
          const campo11 = getCampoValue("CAMPO11", this.campo11);
          const campo12 = getCampoValue("CAMPO12", this.campo12);
          const campo13 = getCampoValue("CAMPO13", this.campo13);
          const campo14 = getCampoValue("CAMPO14", this.campo14);
          const campo15 = getCampoValue("CAMPO15", this.campo15);


          let manufacturingDate;
    if(this.state.campos.filter((campo) => campo.orden == "CAMPO1A")[0].tipoCampo !== "Date" ){
      manufacturingDate = getCampoValue("CAMPO1A", this.campo1A);
    }else{
      manufacturingDate = this.state.manufacturingDate.toISOString();
    }

    let saleDate;
    if(this.state.campos.filter((campo) => campo.orden == "CAMPO0")[0].tipoCampo !== "Date" ){
      saleDate = getCampoValue("CAMPO0", this.campo0);
    }else{
      saleDate = this.state.saleDate.toISOString();
    }



          this._insertNewTemplate(
            this.templateName.value,
            manufacturingDate,
            this.modelo.value,
            saleDate,
            campo1,
            campo2,
            campo3,
            campo4,
            campo5,
            campo6,
            campo7,
            campo8,
            campo9,
            campo10,
            campo11,
            campo12,
            campo13,
            campo14,
            campo15,
            this.descripcion.value
          );
        }

        }
      >
        {i18n.t('guardar')}
      </button>
      <button className="modal-close" onClick={() => this.setState({ showModal: false, insertTemplate: false })}>
        {i18n.t('close')}
      </button>
    </div>
  </div>
)}



                </>
            );

        }
    }
}export default withTranslation()(CertificateGenerator);